import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { ResponseRawErrorT } from "@/models";
import { axiosInstanceNamek } from "@/service/Axios";

import { IMaterial } from "../models/materials.types";
import { MATERIALS_KEYS as KEYS } from "../modules/materials/services/queryKeys";

const getAllMaterials = () => {
  return axiosInstanceNamek
    .get<void, AxiosResponse<IMaterial[]>>(`v1/materials`)
    .then((response) => response.data);
};

export function useGetAllMaterials() {
  return useQuery<IMaterial[], ResponseRawErrorT>({
    queryFn: () => getAllMaterials(),
    queryKey: [KEYS.RECORDS],
    retry: 0,
  });
}
